import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { GameState, IGameStageWinnerSet, IGamePrizeWinner, IGameStateChangedArgs, IGameWonArgs } from '@/components/game/_domain/models';
import { PrizeHelper } from '@/components/game/_domain/helpers/prize-helper';
import { IPrizeElement, IPrizeStructure, IPrizeTicketBook } from '@/components/game/implementations/_default/_domain/models';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import JackpotComponent from '@/components/game/implementations/_default/_components/jackpot';

@Component({
  name: 'BaseWinnerListComponent',
  components: {
    jackpot: JackpotComponent
  }
})
export default class BaseWinnerListComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  protected gameWinnerInfo: IGameStageWinnerSet[] = [];
  private jackpotWon: boolean = false;
  protected isVisible: boolean = false;
  public prizeHelper: PrizeHelper = new PrizeHelper();

  protected handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    const gameState = eventArgs.currentGameState;
    this.updateWinnerListVisibility(gameState);
  }

  protected handleGameWon(eventArgs: IGameWonArgs) {
    this.gameWinnerInfo = eventArgs.gameWinnerInfo;
    this.jackpotWon = eventArgs.isJackpotWon;
  }

  protected updateWinnerListVisibility(gameState: GameState) {
    this.isVisible = gameState === GameState.WinnersDisplayed;
  }

  protected formatPrizeMessage(winnerSet: IGameStageWinnerSet): string {
    return `${winnerSet.prizeName}: ${this.getStagePrizeTotal(winnerSet.winners)}`;
  }

  private formatWinnerMessage(username: string, prizeInPence: number): string {
    return `${username} (${this.prizeHelper.formatPrize(prizeInPence)})`;
  }

  private formatPrize(prizeInPence: number): string {
    return this.prizeHelper.formatPrize(prizeInPence);
  }

  private getStagePrizeTotal(winners: IGamePrizeWinner[]): string {
    let total: number = 0;
    winners.map((winner) => {
      total += winner.prizeInPence;
    });
    return this.prizeHelper.formatPrize(total);
  }

  private get jackpotPrize(): IPrizeElement | null {
    const prizeStructure = this.getPrizeStructure();
    const ticketBook = this.getFirstTicketBook(prizeStructure);
    if (ticketBook) {
      const jackpotPrizes = ticketBook.prizes.filter((prize) => prize.isJackpot);
      if (jackpotPrizes.length > 0) {
        return jackpotPrizes[0];
      }
    }
    return null;
  }

  private getPrizeStructure(): IPrizeStructure | null {
    const game = this.gameController.getGame();
    return game.representation ? game.representation.prizeStructure : null;
  }

  private getFirstTicketBook(prizeStructure: IPrizeStructure): IPrizeTicketBook | null {
    if (prizeStructure && prizeStructure.stakes.length > 0) {
      const stake = prizeStructure.stakes[0];
      if (stake.ticketBooks.length > 0) {
        return stake.ticketBooks[0];
      }
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_base/_components/winner-list/winner-list.component.ts